import { render, staticRenderFns } from "./BookingFormDetails.vue?vue&type=template&id=3ba09796"
import script from "./BookingFormDetails.vue?vue&type=script&lang=js"
export * from "./BookingFormDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports